module.exports = __webpack_public_path__ + "static/media/wear-lor-lev.85d496bc.png";